import {
  ACTION_EDIT_SITE__SUCCESS,
  ACTION_EDIT_SITE__FAIL,
  ACTION_EDIT_SITE__REQUEST,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_SITE__REQUEST:
    case ACTION_EDIT_SITE__SUCCESS:
      return null;

    case ACTION_EDIT_SITE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
